import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const TASK_MODE = {
  ADD: "add",
  EDIT: "edit",
  MODERATE: "moderate",
  VERIFY: "verify",
};

const MODE_CONFIG = {
  [TASK_MODE.ADD]: {
    title: "Add Tasks",
    pageTitle: "Add Task",
    isReadOnly: false,
    isVerify: false,
  },
  [TASK_MODE.EDIT]: {
    title: "Edit Task",
    pageTitle: "Edit Task",
    isReadOnly: false,
    isVerify: false,
  },
  [TASK_MODE.MODERATE]: {
    title: "Moderate Task",
    pageTitle: "Edit Task",
    isReadOnly: true,
    isVerify: false,
  },
  [TASK_MODE.VERIFY]: {
    title: "Verfiy Task",
    pageTitle: "Edit Task",
    isReadOnly: true,
    isVerify: true,
  },
};

function parseSuffix(search) {
  const suffix = search.slice(-3);
  if (suffix === "mod") return TASK_MODE.MODERATE;
  if (suffix === "ver") return TASK_MODE.VERIFY;
  return TASK_MODE.EDIT;
}

export default function useTaskMode(isAddRoute) {
  const location = useLocation();

  return useMemo(() => {
    if (isAddRoute) {
      return { mode: TASK_MODE.ADD, taskId: null, ...MODE_CONFIG[TASK_MODE.ADD] };
    }

    const { search } = location;
    const hasId = search.startsWith("?id=");
    const taskId = hasId ? search.slice(4) : null;
    const mode = hasId ? parseSuffix(search) : null;

    if (!hasId || !mode) {
      return { mode: null, taskId: null, title: "", pageTitle: "", isReadOnly: false, isVerify: false };
    }

    return { mode, taskId, ...MODE_CONFIG[mode] };
  }, [isAddRoute, location.search]);
}
